export default {
  brandColor1: '#304040',
  complimentaryColor1: '#fff',
  brandColor2: '#304040',
  complimentaryColor2: '#fff',
};
